import { useRouter } from "next/router";
import { useContext } from "react";
import Head from "next/head";
import dynamic from "next/dynamic";
import { GlobalContext } from "../../stores/use_global_state";
import Layout from "../../components/layout";
import getCommonLocales from "../../locales/locales_common";
import getErrorLocales from "../../locales/locales_error";
import getRemoveBgPageLocales from "../../locales/locales_remove_bg";
import getPricingLocales from "../../locales/locales_pricing";
import EraseAndReplaceLayout from "../../components/erase_and_replace/EraseAndReplaceLayout";
const DynamicEraseAndReplaceWrapper = dynamic(() => import("../../components/erase_and_replace/EraseAndReplaceWrapper"));

export default function EraseAnReplace({ image_url }) {
	const { locale } = useRouter();
	const { state } = useContext(GlobalContext);

	const dictionary = { ...getCommonLocales(locale), ...getErrorLocales(locale), ...getRemoveBgPageLocales(locale), ...getPricingLocales(locale) };

	const pageLink = image_url ? `https://bgrem.ai/photo-into-painting/?image_url=${image_url}` : "https://bgrem.ai/photo-into-painting/";

	let title = dictionary["page_erase_faq_title"];
	let description = dictionary["page_erase_faq_description"];
	let ogTitle = title;
	let ogDescription = description;

	const getCanonicalLink = (locale) => {
		const enList = ["en", "ja", "ar"];

		if (enList.includes(locale)) {
			return `https://bgrem.ai/erase-and-replace/`;
		} else {
			return `https://bgrem.ai/${locale}/erase-and-replace/`;
		}
	};

	return (
		<Layout mainClassName={`remove_bg magic_bg avatar-layout`}>
			<Head>
				<title>{title}</title>
				<meta name="description" content={description} />
				<meta property="og:type" content="website" />
				<meta property="og:title" content={ogTitle} />
				<meta property="og:description" content={ogDescription} />
				<meta property="og:url" content={pageLink} />
				<meta property="og:image" content={image_url ? image_url : "https://bgrem.ai/seo/og-styling.jpg"} />
				<meta property="og:site_name" content="bgrem" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:section" content="Turn picture into painting with AI" />
				<meta name="twitter:title" content={ogTitle} />
				<meta name="twitter:description" content={ogDescription} />
				<meta property="twitter:card" content="summary_large_image" />
				<meta property="twitter:image:src" content={image_url ? image_url : "https://bgrem.ai/seo/og-styling.jpg"} />
				<meta name="twitter:image" content={image_url ? image_url : "https://bgrem.ai/seo/og-styling.jpg"} />
				<link rel="canonical" href={getCanonicalLink(locale)} />
			</Head>

			{state.eraseAndReplaceImg.length < 1 && <EraseAndReplaceLayout dictionary={dictionary} />}
			{state.eraseAndReplaceImg.length > 0 && <DynamicEraseAndReplaceWrapper dictionary={dictionary} />}
		</Layout>
	);
}

export async function getServerSideProps(context) {
	const image_url = context.query.image_url || null;
	return {
		props: { image_url },
	};
}
